import { QueryClient } from "@tanstack/react-query";

// Singleton QueryClient — exported so non-component code (api/* helpers,
// websocket handlers) can call invalidateQueries without prop-drilling.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Don't refetch every active query when the tab/window regains focus —
      // it was re-fetching the whole settings/billing panel (and flashing
      // loaders) on every alt-tab. Data still refreshes on mount, navigation,
      // and explicit invalidation.
      refetchOnWindowFocus: false,
      // Keep cached data for 30 min after a view unmounts so returning to a
      // page renders from cache instead of cold-reloading (and re-hitting the
      // slow Stripe-backed billing endpoints).
      gcTime: 30 * 60 * 1000,
    },
  },
});
